<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = ["cpi","cpa","cpc","cpe"].map(v => {
			return { value: v, label: v.toUpperCase() };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

